export default "__VITE_ASSET__aA7vsVwp__"